module.exports = __webpack_public_path__ + "static/media/shingan_mok01.3e74b7b5.png";